import styled from 'styled-components';

export const Logo = styled.img`
  display: block;
  height: 60px;
  margin: 16px auto;
  cursor: pointer;
  flex-shrink: 0;
`;
